import React, { Component } from "react";
import Navbar from "./global-components/navbar";
import PageHeader from "./global-components/page-header";
import CallToActionV1 from "./section-components/call-to-action-v1";
import Footer from "./global-components/footer";
import { withAppData } from "../app/withAppData";
import PolicyRepository from "../api/modules/policy/repo";

class FaqV1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      policyData: null,
      loading: true,
    };
  }

  async componentDidMount() {
    try {
      const data = await PolicyRepository.getAllPolicies(this.props.appData.lang);
      this.setState({ policyData: data, loading: false });
    } catch (error) {
      this.setState({ loading: false });
    }
  }

  render() {
    const { sss, lang, pageConfig } = this.props.appData;
    const faqConfig = pageConfig?.faq?.settings?.translations?.[lang] || {};
    const breadcrumbImg = pageConfig?.faq?.settings?.cover;
    const { policyData, loading } = this.state;

    if (loading) {
    return (
      <div>
        <Navbar />
        <PageHeader lang={lang} Img={breadcrumbImg} headertitle="Yükleniyor..." subheader="Yükleniyor..." />
        <div className="container">
          <div className="text-center">
            {lang === "tr" ? "Yükleniyor..." : "Loading..."}
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div>
      <Navbar />
      <PageHeader lang={lang} Img={breadcrumbImg} headertitle={faqConfig.title || "Sıkça Sorulan Sorular"} subheader={faqConfig.title || "Sıkça Sorulan Sorular"} />

      <div className="ltn__faq-area mb-100">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="ltn__faq-inner ltn__faq-inner-2">
                {/* SSS Section Heading */}
                {sss && sss.faqs && Array.isArray(sss.faqs) && sss.faqs.length > 0 && (
                  <div className="section-title-area ltn__section-title-2--- mb-30">
                    <h3>
                        {lang === 'en' ? 'Frequently Asked Questions' : 'Sıkça Sorulan Sorular'}
                    </h3>
                  </div>
                )}
                
                <div className="accordion" id="accordion_2">
                  {/* Dynamic SSS Cards */}
                  {sss && sss.faqs && Array.isArray(sss.faqs) && sss.faqs.map((item, index) => {
                    const t = item.translations?.[lang] || {};
                    const hdrId = `sss_h_${index}`;
                    const colId = `sss_c_${index}`;
                    return (
                      <div className="accordion-item" key={item.id || index}>
                        <h2 className="accordion-header" id={hdrId}>
                          <button
                            className={`accordion-button ${index === 0 ? "" : "collapsed"}`}
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#${colId}`}
                            aria-expanded={index === 0 ? "true" : "false"}
                            aria-controls={colId}
                          >
                            {t.question || 'Soru'}
                          </button>
                        </h2>
                        <div
                          id={colId}
                          className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
                          aria-labelledby={hdrId}
                          data-bs-parent="#accordion_2"
                        >
                          <div className="accordion-body">
                            <div
                              dangerouslySetInnerHTML={{
                                __html: t.answer || 'Cevap bulunamadı',
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <h3 className="mt-50">{lang === 'en' ? 'Policies' : 'Politikalar'}</h3>
                <div className="accordion" id="accordion_3">
                    {/* KVKK Card */}
                  {policyData?.dataProtectionNotice && (
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="kvkk_header">
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#kvkk_collapse"
                          aria-expanded="true"
                          aria-controls="kvkk_collapse"
                        >
                          {policyData.dataProtectionNotice?.data
                                  ?.translations?.[lang]?.title}
                        </button>
                      </h2>
                      <div
                        id="kvkk_collapse"
                        className="accordion-collapse collapse show"
                        aria-labelledby="kvkk_header"
                        data-bs-parent="#accordion_3"
                      >
                        <div className="accordion-body" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                policyData.dataProtectionNotice?.data
                                  ?.translations?.[lang]?.content ||
                                "KVKK metni bulunamadı",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Aydınlatma Metni Card */}
                  {policyData?.disclosure && (
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="aydinlatma_header">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#aydinlatma_collapse"
                          aria-expanded="false"
                          aria-controls="aydinlatma_collapse"
                        >
                          {policyData.disclosure?.data
                                  ?.translations?.[lang]?.title}
                        </button>
                      </h2>
                      <div
                        id="aydinlatma_collapse"
                        className="accordion-collapse collapse"
                        aria-labelledby="aydinlatma_header"
                        data-bs-parent="#accordion_3"
                      >
                        <div className="accordion-body" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                policyData.disclosure?.data?.translations?.[
                                  lang
                                ]?.content || "Aydınlatma metni bulunamadı",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CallToActionV1 />
      <Footer />
    </div>
  );
  }
}

export default withAppData(FaqV1);
